import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 船種マスターリポジトリ
const enterpriseManningVesselCategoryRepository = AiseaApiFactory.get(
  "enterpriseManningVesselCategory"
);

const ManningVesselCategoryService = (() => {
  let _enterpriseManningVesselCategories = null;

  const fetch = async () => {
    const res = await enterpriseManningVesselCategoryRepository.search();
    if (!res || !res.status) {
      throw res;
    }

    _enterpriseManningVesselCategories = res.data;

    return _enterpriseManningVesselCategories;
  };

  const clear = () => {
    _enterpriseManningVesselCategories = null;
  };

  const findById = id => {
    if (!_enterpriseManningVesselCategories) {
      return null;
    }
    return _enterpriseManningVesselCategories.manning_vessel_categories.find(
      category => category.id === id
    );
  };

  return {
    fetch,
    clear,
    findById,
  };
})();

export default ManningVesselCategoryService;
